/* eslint-disable */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { BasicFormInputComponent } from "../../basic/basic-form-input.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { CabLabelComponent } from "../cab-label/cab-label.component";

@Component({
  selector: "app-cab-select",
  templateUrl: "./cab-select.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CabLabelComponent,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class CabSelectComponent extends BasicFormInputComponent {
  @Input() options: any;
  @Input() width = "100%";
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() bindLabel = "name";
  @Input() bindValue = "id";
  @Input() onTranslate = true;
  @Input() clearable = true;
  @Input() multiple = false;
  @Input() showArrow = false;
  @Output() onChange = new EventEmitter<any>();
  @Input() notFoundText = "SELECT.NOT_FOUND";

  ngOnInit() {
    super.ngOnInit();

    if (this.onTranslate) this.translateOptions();
  }

  public compareWithFunc(a: any, b: string) {
    let res = false;
    if (a[this.bindValue] && b) {
      res = a[this.bindValue] == b;
    }
    return res;
  }

  translateOptions(): void {
    if (this.options) {
      this.options.forEach((option: any) => {
        if (option[this.bindLabel]) {
          option[this.bindLabel] = this._translateService.instant(
            option[this.bindLabel]
          );
        }
      });
    }
  }
}
